// // import React from 'react';
// // import CountUp from 'react-countup';
// // import interiorDesignIcon from '../img/icon/interior-designs.png'; // Adjust the path  src/img/icon/certificate.png
// // import recommendIcon from '../img/icon/recommend.png'; // Adjust the path
// // import experienceIcon from '../img/icon/collabration.png'; // Adjust the path
// // import experienceIcons from '../img/icon/certificate.png'; // Adjust the path



// // const Stack = () => {
// //   return (
// //     <section className="counter-section stack">
// //       <div className="container">
// //         {/* <h1 className="main-title">Counter Section</h1> */}
// //         <div className="row" style={{ marginTop: '-180px' }}>
// //           <div className="col-lg-3 col-sm-6">
// //             <div className="counter-count">
// //               <img src={experienceIcons} alt="Experience Icon" height="50px" />
// //               <span className="count">
// //                 <CountUp start={0} end={6} duration={4} />
// //               </span>
// //               <h3 style={{fontSize:'20px'}}>Courses</h3>
// //             </div>
// //           </div>
// //           <div className="col-lg-3 col-sm-6">
// //             <div className="counter-count">
// //               <img src={experienceIcon} alt="Experience Icon" height="50px" />
// //               <span className="count">
// //                 <CountUp start={0} end={50} duration={3} />
// //               </span>
// //               <h3 style={{fontSize:'20px'}}>Corporate Partnership</h3>

// //             </div>
// //           </div>



// //           <div className="col-lg-3 col-sm-3">
// //             <div className="counter-count">
// //               <img src={interiorDesignIcon} alt="Branches Icon" height="50px" />
// //               <span className="count">
// //                 <CountUp start={0} end={4} duration={4} />
// //               </span>
// //               <h3 style={{fontSize:'20px'}}>Branches</h3>
// //             </div>
// //           </div>


// //           <div className="col-lg-3 col-sm-6">
// //             <div className="counter-count">
// //               <img src={recommendIcon} alt="Experience Icon" height="50px" />
// //               <span className="count">
// //                 <CountUp start={0} end={1000} duration={2.5} />
// //               </span>
// //               <h3 style={{fontSize:'20px'}}>Placements</h3>
// //             </div>
// //           </div>

// //         </div>
// //       </div>
// //     </section>
// //   );
// // };

// // export default Stack;























// import React from 'react';
// import CountUp from 'react-countup';
// import interiorDesignIcon from '../img/icon/interior-designs.png'; // Adjust the path  src/img/icon/certificate.png
// import recommendIcon from '../img/icon/recommend.png'; // Adjust the path
// import experienceIcon from '../img/aaaservices/icons8-courses-64 (1).png'; // Adjust the path
// import experienceIcons from '../img/aaaservices/icons8-get-help-48.png'; 

// const Stack = () => {
//   return (
//     <section className="counter-section stack">
//       <div className="container">
        
//         <div className="row" style={{ marginTop: '464px' }}>
//           <div className="col-lg-3 col-sm-6">
//             <div className="counter-count">
//               <div>
//                 <img src={experienceIcons} alt="Experience Icon" height="50px" />
//               </div>
//               <span className="count" style={{ display: 'inline',fontSize:'40px' }}>
//                 <CountUp start={0} end={6} duration={5} />
//               </span>
//               <span style={{ display: 'inline', marginLeft: '5px',color:'white', fontSize:'40px' }}>+</span> 

//               <h3 style={{ fontSize: '20px' ,fontWeight:'400'}}>TECHNO TALKS</h3>
//             </div>
//           </div>
//           <div className="col-lg-3 col-sm-6">
//             <div className="counter-count">
//               <div>
//                 <img src={experienceIcon} alt="Experience Icon" height="50px" />
//               </div>
//               <span className="count" style={{ display: 'inline',fontSize:'40px' }}>
//                 <CountUp start={0} end={50} duration={4} />
//               </span>
//               <span style={{ display: 'inline', marginLeft: '5px' ,color:'white', fontSize:'40px'}}>+</span> 
//               <h3 style={{ fontSize: '20px',fontWeight:'400'}}>COURSES</h3>
//             </div>
//           </div>

//           <div className="col-lg-3 col-sm-3">
//             <div className="counter-count">
//               <div>
//                 <img src={interiorDesignIcon} alt="Branches Icon" height="50px" />
//               </div>
//               <span className="count" style={{ display: 'inline',fontSize:'40px' }}>
//                 <CountUp start={0} end={1} duration={5} />
//               </span>
//               {/* <span style={{ display: 'inline', marginLeft: '5px' ,color:'white',  fontSize:'60px'}}>+</span>  */}
//               <h3 style={{ fontSize: '20px',fontWeight:'400'}}>JOBS</h3>
//             </div>
//           </div>

//           <div className="col-lg-3 col-sm-6">
//             <div className="counter-count">
//               <div>
//                 <img src={recommendIcon} alt="Experience Icon" height="50px" />
//               </div>
//               <span className="count" style={{ display: 'inline',fontSize:'40px' }}>
//                 <CountUp start={0} end={1000} duration={3} />
//               </span>
//               <span style={{ display: 'inline', marginLeft: '5px' ,color:'white', fontSize:'40px' }}>+</span> 
//               <h3 style={{ fontSize: '20px',fontWeight:'400' }}>TRAINERS</h3>
//             </div>
//           </div>

//           {/* <div className="col-lg-3 col-sm-6">
//             <div className="counter-count">
//               <div>
//                 <img src={recommendIcon} alt="Experience Icon" height="50px" />
//               </div>
//               <span className="count" style={{ display: 'inline',fontSize:'40px' }}>
//                 <CountUp start={0} end={1000} duration={3} />
//               </span>
//               <span style={{ display: 'inline', marginLeft: '5px' ,color:'white', fontSize:'40px' }}>+</span> 
//               <h3 style={{ fontSize: '20px',fontWeight:'400' }}>SPEAKERS</h3>
//             </div>
//           </div> */}

//         </div>
//       </div>
//     </section>
//   );
// };

// export default Stack;




import React, { useState } from "react";

const PROGRAMS = [
  "Mechanical CAD Design",
  "Industrial Automation",
  "Robotics Engineering",
  "PLC & SCADA",
  "CNC Programming",
];

export default function EnquirySection() {
  const [form, setForm] = useState({
    name: "",
    mobile: "",
    email: "",
    program: "",
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    if (!form.name || !form.mobile || !form.email || !form.program) return;
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 3000);
  };

  return (
    <section className="enq-section">
      <style>{`
        .enq-section {
          --navy: #14285c;
          --navy-dark: #0d1d45;
          --orange: #f37021;
          --peach-bg: #fdf1e7;
          --peach-border: #f6ddc4;
          --text-muted: #5b6474;
          box-sizing: border-box;
          width: 100%;
          padding: 24px 16px;
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
        }
        .enq-section *, .enq-section *::before, .enq-section *::after {
          box-sizing: border-box;
        }
        .enq-card {
          max-width: 1280px;
          margin: 0 auto;
          background: var(--peach-bg);
          border: 1px solid var(--peach-border);
          border-radius: 20px;
          padding: 32px;
          display: flex;
          flex-wrap: wrap;
          gap: 32px;
          align-items: flex-start;
        }
        .enq-left {
          flex: 1 1 280px;
          min-width: 260px;
        }
        .enq-heading {
          font-size: 26px;
          line-height: 1.25;
          font-weight: 800;
          margin: 0 0 12px 0;
          color: var(--navy);
        }
        .enq-heading .accent {
          color: var(--orange);
        }
        .enq-sub {
          color: var(--text-muted);
          font-size: 14.5px;
          line-height: 1.5;
          margin: 0 0 24px 0;
          max-width: 320px;
        }
        .enq-feature {
          display: flex;
          align-items: flex-start;
          gap: 12px;
        }
        .enq-feature-icon {
          flex-shrink: 0;
          width: 44px;
          height: 44px;
          border-radius: 50%;
          background: #ffffff;
          border: 1px solid var(--peach-border);
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .enq-feature-icon svg {
          width: 20px;
          height: 20px;
          stroke: var(--navy);
        }
        .enq-feature-text {
          font-size: 14px;
          line-height: 1.4;
          color: var(--navy);
          font-weight: 600;
          padding-top: 4px;
        }
        .enq-feature-text span {
          display: block;
          font-weight: 400;
          color: var(--text-muted);
        }

        .enq-right {
          flex: 2.4 1 480px;
          min-width: 280px;
        }
        .enq-fields {
          display: grid;
          grid-template-columns: repeat(4, minmax(0, 1fr)) auto;
          gap: 16px;
          align-items: end;
        }
        .enq-field {
          display: flex;
          flex-direction: column;
          gap: 8px;
          min-width: 0;
        }
        .enq-label {
          font-size: 13.5px;
          font-weight: 600;
          color: var(--navy);
        }
        .enq-label .req {
          color: #e0374a;
          margin-left: 2px;
        }
        .enq-input,
        .enq-select {
          width: 100%;
          height: 46px;
          padding: 0 14px;
          font-size: 14px;
          border-radius: 10px;
          border: 1px solid #e3d8c9;
          background: #ffffff;
          color: var(--navy);
          outline: none;
          appearance: none;
          -webkit-appearance: none;
          transition: border-color 0.15s ease, box-shadow 0.15s ease;
          font-family: inherit;
        }
        .enq-select {
          background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2314285c' stroke-width='2'><polyline points='6 9 12 15 18 9'/></svg>");
          background-repeat: no-repeat;
          background-position: right 12px center;
          background-size: 16px;
          padding-right: 36px;
        }
        .enq-input::placeholder {
          color: #a8a2ac;
        }
        .enq-input:focus,
        .enq-select:focus {
          border-color: var(--navy);
          box-shadow: 0 0 0 3px rgba(20, 40, 92, 0.12);
        }
        .enq-submit {
          height: 46px;
          padding: 0 22px;
          border: none;
          border-radius: 10px;
          background: var(--navy);
          color: #ffffff;
          font-size: 14px;
          font-weight: 700;
          cursor: pointer;
          white-space: nowrap;
          transition: background 0.15s ease, transform 0.1s ease;
        }
        .enq-submit:hover {
          background: var(--navy-dark);
        }
        .enq-submit:active {
          transform: translateY(1px);
        }
        .enq-submit:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        .enq-trust {
          display: flex;
          flex-wrap: wrap;
          gap: 28px;
          margin-top: 18px;
        }
        .enq-trust-item {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 13.5px;
          color: var(--navy);
        }
        .enq-trust-item svg {
          width: 16px;
          height: 16px;
          stroke: var(--navy);
          flex-shrink: 0;
        }
        .enq-toast {
          margin-top: 14px;
          font-size: 13.5px;
          font-weight: 600;
          color: #1a7a3c;
        }

        /* Tablet */
        @media (max-width: 900px) {
          .enq-fields {
            grid-template-columns: 1fr 1fr;
          }
          .enq-submit {
            grid-column: 1 / -1;
            width: 100%;
          }
        }

        /* Mobile */
        @media (max-width: 560px) {
          .enq-section {
            padding: 16px 10px;
          }
          .enq-card {
            padding: 20px;
            border-radius: 16px;
            gap: 24px;
          }
          .enq-heading {
            font-size: 22px;
          }
          .enq-fields {
            grid-template-columns: 1fr;
          }
          .enq-trust {
            gap: 16px;
          }
        }
      `}</style>

      <div className="enq-card">
        <div className="enq-left">
          <h2 className="enq-heading">
            <span className="accent">Have</span> Questions?
            <br />
            We're Here to Help!
          </h2>
          <p className="enq-sub">
            Share your details and our team will get in touch with you.
          </p>

          <div className="enq-feature">
            <div className="enq-feature-icon">
              <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 2l8 4v6c0 5-3.4 8.4-8 10-4.6-1.6-8-5-8-10V6l8-4z" />
                <path d="M9 12l2 2 4-4" />
              </svg>
            </div>
            <div className="enq-feature-text">
              Talk to our experts
              <span>about courses, batches, placements &amp; more.</span>
            </div>
          </div>
        </div>

        <div className="enq-right">
          <div className="enq-fields">
            <div className="enq-field">
              <label className="enq-label" htmlFor="enq-name">
                Your Name<span className="req">*</span>
              </label>
              <input
                id="enq-name"
                className="enq-input"
                type="text"
                name="name"
                placeholder="Enter your name"
                value={form.name}
                onChange={handleChange}
              />
            </div>

            <div className="enq-field">
              <label className="enq-label" htmlFor="enq-mobile">
                Mobile Number<span className="req">*</span>
              </label>
              <input
                id="enq-mobile"
                className="enq-input"
                type="tel"
                name="mobile"
                placeholder="Enter your mobile number"
                value={form.mobile}
                onChange={handleChange}
              />
            </div>

            <div className="enq-field">
              <label className="enq-label" htmlFor="enq-email">
                Email Address<span className="req">*</span>
              </label>
              <input
                id="enq-email"
                className="enq-input"
                type="email"
                name="email"
                placeholder="Enter your email"
                value={form.email}
                onChange={handleChange}
              />
            </div>

            <div className="enq-field">
              <label className="enq-label" htmlFor="enq-program">
                Interested In<span className="req">*</span>
              </label>
              <select
                id="enq-program"
                className="enq-select"
                name="program"
                value={form.program}
                onChange={handleChange}
              >
                <option value="" disabled>
                  Select a program
                </option>
                {PROGRAMS.map((p) => (
                  <option key={p} value={p}>
                    {p}
                  </option>
                ))}
              </select>
            </div>

            <button className="enq-submit" onClick={handleSubmit}>
              Submit Enquiry
            </button>
          </div>

          <div className="enq-trust">
            <div className="enq-trust-item">
              <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <rect x="4" y="10" width="16" height="10" rx="2" />
                <path d="M8 10V7a4 4 0 0 1 8 0v3" />
              </svg>
              Your information is safe with us. We will never share your details.
            </div>
            <div className="enq-trust-item">
              <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <path d="M13 2L4 14h7l-1 8 9-12h-7l1-8z" />
              </svg>
              Quick response within 24 hours
            </div>
          </div>

          {submitted && (
            <div className="enq-toast">
              Thanks! Your enquiry has been submitted — we'll reach out soon.
            </div>
          )}
        </div>
      </div>
    </section>
  );
}